import { render } from "./ConfigurationLocations.vue?vue&type=template&id=11d250b8&scoped=true"
import script from "./ConfigurationLocations.vue?vue&type=script&lang=js"
export * from "./ConfigurationLocations.vue?vue&type=script&lang=js"

import "./ConfigurationLocations.vue?vue&type=style&index=0&id=11d250b8&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d250b8"]])

export default __exports__